"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
const common_components_1 = require("@zapier/common-components");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_1 = require("../common");
const common_utils_1 = require("@zapier/common-utils");
const FieldFocusContext_1 = require("../FieldFocusContext");
const hooks_1 = require("../../hooks");
const PrettyText_1 = __importDefault(require("../PrettyText"));
const FieldFocusContext_2 = require("../FieldFocusContext/FieldFocusContext");
const utils_1 = require("./utils");
const fixDuplicateKeys_1 = __importDefault(require("./fixDuplicateKeys"));
const Styles = common_utils_1.labelStyles(__filename, {
    pairContainer: {
        marginBottom: theme_1.Spacing.small,
    },
    duplicateKeyWarning: {
        display: 'flex',
        alignItems: 'center',
    },
});
const gridColumns = '2fr 5fr 40px';
const gridGap = theme_1.Spacing.extraSmall;
const buttonColor = 'greyAlt';
const KeyValuePairEditor = (props) => {
    const { pair, index, existingKeys } = props;
    const { key, value } = pair;
    const [tempKey, updateTempKey] = react_1.useState(key);
    react_1.useEffect(() => updateTempKey(key), [key, existingKeys]);
    const onRemove = (e) => {
        e.preventDefault();
        props.onRemove(index);
    };
    const onBlurKey = () => props.onChangeKey(index, tempKey);
    const onChangeKey = (e) => updateTempKey(e.target.value);
    const onChangeValue = (e) => props.onChangeValue(index, e);
    const indexInExistingKeys = existingKeys.indexOf(tempKey);
    const didFindKey = indexInExistingKeys !== -1;
    const didFindDuplicateKey = indexInExistingKeys !== index;
    const shouldShowDuplicateKeyWarning = didFindKey && didFindDuplicateKey;
    return (common_utils_1.isolateComponent(react_1.Fragment, null,
        common_utils_1.isolateComponent(common_components_1.GridLayout, { columns: gridColumns, gap: gridGap },
            common_utils_1.isolateComponent(common_1.TextInput, { disabledText: props.disabledText, isDisabled: props.isDisabled, isFullWidth: true, onBlur: onBlurKey, onChange: onChangeKey, value: tempKey }),
            common_utils_1.isolateComponent(PrettyText_1.default, { choiceGroups: props.choiceGroups, disabledText: props.disabledText, id: props.id, initialValue: value, isDisabled: props.isDisabled, key: props.id, onBlur: () => { }, onChange: onChangeValue, onFocus: () => { } }),
            common_utils_1.isolateComponent(design_system_1.IconButton, { color: buttonColor, disabled: props.isDisabled, icon: "formX", label: "Remove this item", onClick: onRemove, size: "small", tooltipPosition: "north", type: "button" })),
        shouldShowDuplicateKeyWarning && (common_utils_1.isolateComponent("div", { css: Styles.duplicateKeyWarning },
            common_utils_1.isolateComponent("div", { css: { marginTop: 4 } },
                common_utils_1.isolateComponent(design_system_1.Icon, { color: "yellow500", name: "alertTriangle", size: 14 })),
            common_utils_1.isolateComponent(design_system_1.Spacer, { width: theme_1.Spacing.extraSmall }),
            common_utils_1.isolateComponent("div", null,
                common_utils_1.isolateComponent(design_system_1.Text, { color: "yellow500", type: "allCaps700" }, "Duplicate key"),
                "\u00A0",
                common_utils_1.isolateComponent(design_system_1.Text, { color: "yellow500", type: "altText800" }, "Just a head's up that we'll have to automatically adjust the key."))))));
};
const DEFAULT_VALUE = { '': '' };
function DictionaryField(props) {
    const { value: dictionary = DEFAULT_VALUE } = props;
    const { onBlur } = FieldFocusContext_2.useFieldFocusContext();
    const [idSuffix, incrementIdSuffix] = hooks_1.useCounter(0);
    const getKey = (index) => `pair-${index}-${idSuffix}`;
    const pairs = utils_1.dictionaryToAssociativeList(utils_1.ensureAnEmptyPair(dictionary));
    const onChange = (newPairs) => {
        props.onChange(utils_1.associativeListToDictionary(fixDuplicateKeys_1.default(newPairs)));
    };
    const onAdd = (e) => {
        e.preventDefault();
        onChange(utils_1.appendEmptyPair(pairs));
    };
    const onRemove = (index) => {
        onChange(utils_1.remove(pairs, index));
        incrementIdSuffix();
        onBlur();
    };
    const onChangeKey = (index, newKey) => {
        onChange(utils_1.updateKey(pairs, index, newKey));
    };
    const onChangeValue = (index, value) => {
        onChange(utils_1.updateValue(pairs, index, value));
    };
    return (common_utils_1.isolateComponent(react_1.Fragment, null,
        lodash_1.map(pairs, (pair, index) => (common_utils_1.isolateComponent(FieldFocusContext_1.ExclusiveFieldFocus, { key: index },
            common_utils_1.isolateComponent("div", { css: Styles.pairContainer },
                common_utils_1.isolateComponent(KeyValuePairEditor, { choiceGroups: props.choiceGroups, disabledText: props.disabledText, existingKeys: pairs.map(({ key }) => key), id: getKey(index), index: index, isDisabled: props.isDisabled, onChangeKey: onChangeKey, onChangeValue: onChangeValue, onRemove: onRemove, pair: pair }))))),
        common_utils_1.isolateComponent(common_components_1.GridLayout, { columns: gridColumns, gap: gridGap },
            common_utils_1.isolateComponent("div", null),
            common_utils_1.isolateComponent("div", null),
            common_utils_1.isolateComponent(design_system_1.IconButton, { color: buttonColor, disabled: props.isDisabled, icon: "formAdd", label: "Add another item", onClick: onAdd, size: "small", tooltipPosition: "north", type: "button" }))));
}
exports.default = DictionaryField;
